import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children, requireRole }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen bg-[#040812] flex items-center justify-center"
      >
        <div className="font-mono text-xs text-slate-500 tracking-widest">
          AUTHENTICATING…
        </div>
      </div>
    );
  }

  // Determine which login page to redirect to based on current path
  const isCrmRoute = location.pathname.startsWith("/crm");
  const loginPath = isCrmRoute ? "/crm/login" : "/admin/login";

  if (!user) {
    return <Navigate to={loginPath} replace state={{ from: location.pathname }} />;
  }

  // Enforce role if requested; otherwise infer from route
  const requiredRole =
    requireRole ||
    (location.pathname.startsWith("/admin") ? "admin" : null); // /crm allows any authenticated user

  if (requiredRole && user.role !== requiredRole) {
    // Wrong-role users get bounced to their own home
    const home = user.role === "admin" ? "/admin" : "/crm";
    return <Navigate to={home} replace />;
  }

  return children;
};

export default ProtectedRoute;
